import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import FieldSet from 'modules/reviews/components/FieldSet'
import AccessGroupPicker from 'modules/reviews/components/New/AccessGroupPicker'
import type ReviewRespondentsForm from 'modules/reviews/lib/RespondentsFactorialForm'

interface Props {
  reviewForm: ReviewRespondentsForm
  contractVersions: ContractVersions
}

function Target({ reviewForm, contractVersions }: Props) {
  return (
    <FieldSet
      title={i18n.t('surveys.performance.new.form.target.title')}
      description={i18n.t('surveys.performance.new.form.target.description')}
    >
      <AccessGroupPicker form={reviewForm} contractVersions={contractVersions} />
    </FieldSet>
  )
}

export default observer(Target)
